import tw from 'twin.macro';

import { GarmOverview } from './GarmOverview';
import { CategoriesOverview } from './CategoriesOverview';
import { EntitiesOverview } from './EntitiesOverview';
import { TABLE_VIEW, useShowDetailsContext } from '@insights_module/context/ShowDetailsContext';
import { DoubleArrowToRight } from '@icons/DoubleArrowToRight';
import { ShowMetadataOverview } from '@insights_module/components/show_details_screen/ShowMetadataOverview';

const SIDEBAR_HEADER_HEIGHT = '38';

const SidebarWrapper = tw.div`flex w-[371px] h-full border-l border-gray-3 bg-neutral-background p-[16px]`;
const HeaderIconWrapper = tw.div`flex flex-col items-center justify-center h-[${SIDEBAR_HEADER_HEIGHT}px] w-[42px] cursor-pointer hover:bg-gray-3`;

export const ShowSidebarButton = () => {
  const { showSideBar, setShowSideBar } = useShowDetailsContext();

  return (
    <HeaderIconWrapper
      tw='overflow-hidden shadow-ui'
      css={[showSideBar && tw`w-0`]}
      onClick={() => setShowSideBar(true)}>
      <DoubleArrowToRight tw='fill-text-and-icon rotate-180' />
    </HeaderIconWrapper>
  );
};

export const ShowDetailsSideBar = () => {
  const { tableView } = useShowDetailsContext();
  return (
    <SidebarWrapper>
      {tableView === TABLE_VIEW.INFO && <ShowMetadataOverview />}
      {tableView === TABLE_VIEW.GARM && <GarmOverview />}
      {tableView === TABLE_VIEW.CONTEXTUAL && <CategoriesOverview />}
      {tableView === TABLE_VIEW.ENTITIES && <EntitiesOverview />}
    </SidebarWrapper>
  );
};
